import React from "react";
import { connect } from "react-redux";
import { getDesc } from "../../../stores/actions/nomenclature";

const PRO3Features = props => {
 
  let type = "";
  var modeldef = [
    // { type: "", code: "#", desc: "#####" },
    { type: "", code: "#", desc: "#####" },
    { type: "", code: "#", desc: "#####" },
    { type: "", code: "#", desc: "#####" },
    { type: "", code: "#", desc: "#####" },
    { type: "", code: "#", desc: "#####" },
    { type: "", code: "#", desc: "#####" },
    { type: "", code: "#", desc: "#####" },
    { type: "", code: "#", desc: "#####" },
    { type: "", code: "#", desc: "#####" },
    { type: "", code: "#", desc: "#####" },
    // { type: "", code: "#", desc: "#####" }
  ];
  if (
    typeof props.compare != "undefined" &&
    typeof props.compare.nomenclature != "undefined"
  ) {
   
    type = props.type;
    //if (typeof type === "undefined") type = props.type;

    var nomenclature = props.compare.nomenclature.filter(item => {
      if (item.name === type) return item;
    });
    if (nomenclature.length > 0) nomenclature = nomenclature[0];

  
    if (
      typeof props.modelnumber != "undefined" &&
      props.modelnumber.length >= 12
    ) {
      
      var modelnumber = props.modelnumber;
      var BTU_add = "";
      var BTU_pos = 0;
      if(modelnumber.indexOf("_")>-1){
        BTU_pos = modelnumber[modelnumber.indexOf("_")+1];
        BTU_add = "_"+BTU_pos;
        modelnumber = modelnumber.replace(BTU_add,"");
      }

      modeldef[0] = {
        code: modelnumber[0],
        type: nomenclature.nomenclature[1].type,
        desc: getDesc(
          nomenclature.nomenclature[1].trans,
          modelnumber[0],
          true
        )
      };
      modeldef[1] = {
        code: modelnumber[1],
        type: nomenclature.nomenclature[2].type,
        desc: getDesc(nomenclature.nomenclature[2].trans, modelnumber[1])
      };

      // modeldef[2] = {
      //   code: props.modelnumber[2],
      //   type: nomenclature.nomenclature[3].type,
      //   desc: getDesc(nomenclature.nomenclature[3].trans, props.modelnumber[2])
      // };
      

      modeldef[2] = {
        code:
          modelnumber[2] +
          modelnumber[3] +
          modelnumber[4] +
          modelnumber[5] +BTU_add,
        type: nomenclature.nomenclature[3].type,
        desc: getDesc(
          nomenclature.nomenclature[3].trans,
          modelnumber[2] +
          modelnumber[3] +
          modelnumber[4] +
          modelnumber[5] +BTU_add
          
        )
      };
      modeldef[3] = {
        code:           
          modelnumber[6],
        type: nomenclature.nomenclature[4].type,
        desc: getDesc(
          nomenclature.nomenclature[4].trans,
          
          modelnumber[6]
        )
      };
      modeldef[4] = {
        code: modelnumber[7],
        type: nomenclature.nomenclature[5].type,
        desc: getDesc(nomenclature.nomenclature[5].trans, modelnumber[7])
      };
      modeldef[5] = {
        code: modelnumber[8],
        type: nomenclature.nomenclature[6].type,
        desc: getDesc(nomenclature.nomenclature[6].trans, modelnumber[8])
      };
      modeldef[6] = {
        code: modelnumber[9],
        type: nomenclature.nomenclature[7].type,
        desc: getDesc(nomenclature.nomenclature[7].trans, modelnumber[9])
      };
      modeldef[7] = {
        code: modelnumber[10],
        type: nomenclature.nomenclature[8].type,
        desc: getDesc(nomenclature.nomenclature[8].trans, modelnumber[10])
      };
      modeldef[8] = {
        code: modelnumber[11],
        type: nomenclature.nomenclature[9].type,
        desc: getDesc(nomenclature.nomenclature[9].trans, modelnumber[11])
      };
      modeldef[9] = {
        code: modelnumber[12],
        type: nomenclature.nomenclature[10].type,
        desc: getDesc(nomenclature.nomenclature[10].trans, modelnumber[12])
      };
      // modeldef[10] = {
      //   code: props.modelnumber[13],
      //   type: nomenclature.nomenclature[11].type,
      //   desc: getDesc(nomenclature.nomenclature[11].trans, props.modelnumber[13])
      // };
     
    }
  }

  const items = modeldef.map((item, index) => {
    
    if(item.desc ==="#####"){
      return;
    }
    return (
      <React.Fragment key={item.type}>
        <li className={"key brand_Feature_K_" + index}>{item.type}</li>
        <li className={"value brand_Feature_V_" + index}>:&nbsp;&nbsp;{((item.type=='BTU Capacity')?((props.replace_btu)?props.formatNumberValue(props.replace_btu):props.formatNumberValue(item.desc)):item.desc)}</li>
      </React.Fragment>
    );
  });
  return (
    <div
      style={type == "PRO3" ? { width: "100%" } : {}}
      className="brand-features-left"
    >
      <ul>{items}</ul>
    </div>
  );
};
function mapStateToProps(state) {
  return state;
}

export default connect(mapStateToProps)(PRO3Features);
